<template>
  <div class="brand_rank">
    <!-- 8. 品牌排名 -->
    <titleTem :passTitleData="passTitleData"></titleTem>

    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择地区 -->
        <el-col :md="24" :lg="10">
          <div class="option region">
            <div class="item_title">Select Brand:</div>
            <el-select
              remote
              v-model="brandVal"
              clearable
              placeholder="Please input"
              :popper-append-to-body="false"
              @change="changeBrand"
              filterable
              v-el-select-loadmore="loadmore"
              :remote-method="querySearch"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <!-- 选择时间 -->
        <el-col :md="24" :lg="14" v-if="!isMyDate">
          <div class="option time">
            <div class="time">
              <el-row>
                <el-col :md="24" :lg="5">
                  <div class="item_title date_item">Select Time:</div>
                </el-col>
                <el-col :md="24" :lg="19">
                  <el-date-picker
                    @blur="getStartDate"
                    type="date"
                    placeholder="Start date"
                    v-model="startDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsStart"
                  ></el-date-picker>
                  <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
                  <el-date-picker
                    @blur="getEndDate"
                    type="date"
                    placeholder="End date"
                    v-model="endDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsEnd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :md="24" :lg="14" v-else>
          <div class="option time">
            <div class="time">
              <el-row>
                <el-col :md="24" :lg="5">
                  <div class="item_title date_item">Select Time:</div>
                </el-col>
                <el-col :md="24" :lg="19">
                  <DatePicker
                    :startTime="startDate"
                    :endTime="endDate"
                    @startConfirm="startConfirm"
                    @endConfirm="endConfirm"
                    @startCancel="startCancel"
                    @endCancel="endCancel"
                    @startClear="startClear"
                    @endClear="endClear"
                  ></DatePicker>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <!-- 选择品牌 -->
        <!-- <el-col :span="24">
          <div class="option region">
            <div class="item_title">Select Brand:</div>
            <el-select
              remote
              v-model="brandVal"
              clearable
              placeholder="Please choose"
              @change="changeBrand"
              filterable
              v-el-select-loadmore="loadmore"
              :remote-method="querySearch"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :md="24">
          <div class="option region_det">
            <div class="item_title">Select Region:</div>
            <el-tag
              :key="tag.value"
              v-for="tag in dynamicTags"
              closable
              type="info"
              :disable-transitions="false"
              @click="getContent(tag)"
              @close="handleClose(tag)"
            >{{tag.value}}</el-tag>
          </div>
        </el-col> -->

        <el-col :md="24">
          <div class="option region_det">
            <div class="item_title">Select Brand:</div>
            <el-tag
              :key="tag.value"
              v-for="tag in dynamicTags1"
              closable
              type="info"
              :disable-transitions="false"
              @click="getContent1(tag)"
              @close="handleClose1(tag)"
            >{{tag.value}}</el-tag>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="echarts_container bar_style">
      <!-- <EBar :echartsData="echartsData" :numShow="true" :isNodata="isNodata"></EBar> -->
      <ELine :echartsData="echartsData" :isNodata="isNodata"></ELine>
    </div>
  </div>
</template>

<script>
import titleTem from "./Title";
// import EBar from "../echarts/BrandRankBar";
import ELine from "../echarts/BrandRankLine"
import {
  findCompanyByName,
  listofCountries,
  brandHeat,
  brandLine
} from "@/common/js/http/version3Api.js";
import DatePicker from "../mobile/DatePickerLocal";
export default {
  name: "BrandRank",
  components: {
    titleTem,
    ELine,
    DatePicker
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  data() {
    return {
      isNodata: false,
      pickerOptionsStart: {
        disabledDate: time => {
          if(this.endDate === '' || this.endDate !== '') {
            let endDateVal = 1561910461 * 1000;
            if (endDateVal) {
              return time.getTime() < 1561910461 * 1000 || time.getTime() > new Date(this.endDate).getTime();
            }
          }else {
            let endDateVal = this.endDate;
            if(endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if(this.startDate === '') {
            let beginDateVal = 1561910461 * 1000;
            if (beginDateVal) {
              return time.getTime() < 1561910461 * 1000;
            }
          }else {
            let beginDateVal = this.startDate;
            if(beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime();
            }
          }
        }
      },
      passTitleData: {
        titleName: "Brand Popularity Ranking",
        commentTxt:
          "It shows rankings of the brands by public opinion activation in the same industry in regions within a certain time frame (in past 30 days by default)."
      },

      //柱状图数据
      echartsData: [],

      // 搜索条件
      clickState: false,
      regionVal: "",
      brandVal: "",
      startDate: "",
      endDate: "",
      dynamicTags: [],
      options: [],
      dynamicTags1: [],
      options1: [],
      brandArray: [],
      countryArray: [],
      makeArray: [],
      regionalArray: [],
      brandsArray: [],
      formData: {
        pageIndex: 1,
        pageSize: 20
      },
      companyName: '',
      allBrandArray:[]
    };
  },
  created() {
    //屏幕宽度
    if(document.documentElement.clientWidth < 768) this.isMyDate = true
    else this.isMyDate = false
    this.setDate();
  },
  mounted() {
    //this.getlistofCountry();
    this.getCompanyList(this.formData);
    this.getBrandLine();
  },
  methods: {
    querySearch(companyName) {
      findCompanyByName(companyName).then(res => {
        this.brandsArray = res.result;
        this.options1 = this.brandsArray;
      });
    },
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    loadmore() {
      this.formData.pageIndex++;
      this.getCompanyList(this.formData);
    },
    getStartDate() {
      this.getBrandLine()
    },
    getEndDate() {
      this.getBrandLine()
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.regionalArray.filter(item => {
        if (item === tag.value) {
          this.regionalArray.splice(this.regionalArray.indexOf(tag.value), 1);
        }
      });
      this.options.filter(item => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });
      this.regionVal = "";

    },
    getContent(val) {

    },
    handleClose1(tag) {
      this.dynamicTags1.splice(this.dynamicTags1.indexOf(tag), 1);
      //this.brandArray.splice(this.brandArray.indexOf(tag),1);
      this.brandArray.filter(item => {
        if (item === tag.value) {
          this.brandArray.splice(this.brandArray.indexOf(tag.value), 1);
        }
      });

      this.options1.filter(item => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });
      this.brandVal = "";
      this.getBrandLine()

    },
    getContent1(val) {
      this.getBrandLine()
    },
    async getBrandLine() {
      if (this.startDate == null || this.startDate == 'Invalid date') {
        this.startDate = "";
      }
      if (this.endDate == null  || this.endDate == 'Invalid date') {
        this.endDate = "";
      }
      let ids = [];
      this.brandArray.forEach(item => {
        if (this.allBrandArray.filter(i => i.value == item)[0]) {
          const id = this.allBrandArray.filter(i => i.value == item)[0].id;
          ids.push(id)
        } else return;
      });

      let data = {
        companyId: this.$route.query.id,
        companyIds: ids,
        startTime: this.startDate,
        endTime: this.endDate
      };

      let { result } = await brandLine(data);
      let newArray = [];
      let one = newArray.push(result.xAxis.data, result.series);
      this.$set(this.echartsData, "lineData", newArray);
      this.echartsData = this.echartsData.lineData;
      if(this.echartsData[0].length === 0) {
        this.isNodata = true
      }else {
        this.isNodata = false
      }
    },
    getBrandRank() {
      console.log(this.startDate,'最后开始00')
      if (this.startDate == null) {
        this.startDate = "";
      }
      if (this.endDate == null) {
        this.endDate = "";
      }

      let ids = [];
      this.brandArray.forEach(item => {
        const id = this.options1.filter(i => i.value == item)[0].id;
        ids.push(id) 
      });
      let data = {
        // companyNames: this.brandArray,
        companyIds:ids,
        regionalNames: this.regionalArray,
        startTime: this.startDate,
        endTime: this.endDate
      };

      brandHeat(data).then(res => {
        let newsArray = [];
        res.result.series.map(item => item.data.reverse());
        res.result.yAxis.data.reverse();
        let one = newsArray.push(res.result.yAxis.data, res.result.series);
        this.$set(this.echartsData, "lineData", newsArray);
        this.echartsData = this.echartsData.lineData;
        if (this.echartsData[0].length === 0) {
          this.isNodata = true;
        } else {
          this.isNodata = false;
        }
      });
    },
    //获取国家列表
    getlistofCountry() {
      let data = {
        companyId: this.$route.query.id
      };

      listofCountries(data).then(res => {
        this.options = res.result;
        this.options.map(item => {
          item.disabled = false;
          return item;
        });
      });
    },
    //选择国家列表
    changeArea(val) {
      this.clickState = true;
      this.options.filter(item => {
        if (item.value === this.regionVal) {
          item.disabled = true;
        }
      });
      if (this.clickState === true && this.regionVal !== "") {
        this.countryArray.push({ value: this.regionVal });
        for (var i = 0; i < this.countryArray.length; i++) {
          for (var j = i + 1; j < this.countryArray.length; j++) {
            if (this.countryArray[i].value == this.countryArray[j].value) {
              this.countryArray.splice(j, 1);
              j--;
            }
          }
        }
        this.dynamicTags = this.countryArray;
        this.regionalArray.push(val);
      }

    },
    //获取企业信息列表
    getCompanyList(formData) {
      let num = formData.pageIndex * formData.pageSize;
      findCompanyByName('').then(res => {
        this.brandsArray = res.result;
        this.allBrandArray = res.result;
        this.brandsArray.map(item => {
          item.disabled = false;
          return item;
        });
        this.options1 = this.brandsArray.filter((item, index) => {
          return index < num;
        });
      });
    },

    //选择品牌
    changeBrand(val) {
      this.clickState = true;
      this.options1.filter(item => {
        if (item.value === this.brandVal) {
          item.disabled = true;
        }
      });
      this.companyName = val;
      findCompanyByName(this.companyName).then(res => {
        this.brandsArray = res.result;
        this.brandsArray.map(item => {
          item.disabled = false;
          return item;
        });
        this.options1 = this.brandsArray;

      });
      if (this.clickState === true && this.brandVal !== "") {
        this.makeArray.push({ value: this.brandVal });
        for (var i = 0; i < this.makeArray.length; i++) {
          for (var j = i + 1; j < this.makeArray.length; j++) {
            if (this.makeArray[i].value == this.makeArray[j].value) {
              this.makeArray.splice(j, 1);
              j--;
            }
          }
        }
        this.dynamicTags1 = this.makeArray;
        this.brandArray.push(val);
      }
      this.getBrandLine()
    },
    //移动端日期选择
    startConfirm(startTime) {
      this.startDate = this.$moment(new Date(startTime)).format("YYYY-MM-DD");
      this.getBrandLine();
    },
    endConfirm(endTime) {
      this.endDate = this.$moment(new Date(endTime)).format("YYYY-MM-DD");
      this.getBrandLine();
    },
    startCancel() {
      this.startDate = "";
      this.getBrandLine();
    },
    endCancel() {
      this.endDate = "";
      this.getBrandLine();
    },
    startClear() {
      this.startDate = "";
      this.getBrandLine();
    },
    endClear() {
      this.endDate = "";
      this.getBrandLine();
    }
  },
  watch: {
    startDate(newValue) {
      if (newValue == null) {
        this.getBrandLine();
      }
    },
    endDate(newValue) {
      if (newValue == null) {
        this.getBrandLine();
      }
    }
  }
};
</script>

<style scoped>
/* .echarts_container > div {
  height: auto !important;
} */
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 125px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
}
@media screen and (max-width: 1024px) {
  .time .date_item {
    text-align: left !important;
  }
}
</style>
